import { render } from "./collectionsGridBlock.vue?vue&type=template&id=75b6680d&ts=true"
import script from "./collectionsGridBlock.vue?vue&type=script&lang=ts"
export * from "./collectionsGridBlock.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__